import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Page } from "@/uiKit/atoms/page/Page.tsx";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";
import { PageHeader } from "@/uiKit/atoms/page/PageHeader.tsx";
import { NursePatientListCard } from "@/uiKit/organisms/PatientsList/NursePatientListCard.tsx";

export const PatientListForNursesPage: React.FC = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <Page id="nurse-patients-list-page">
      <PageHeader id="nurse-patients-list-page-title" title={t("pages.patients.title")} />
      <PageContent id="nurse-patients-list-page-content">
        <NursePatientListCard className={styles.patientsList} />
      </PageContent>
    </Page>
  );
};

const makeStyles = () => ({
  patientsList: css({
    flex: "1 1",
  }),
});
